<div class="loader-overlay" *ngIf="loaderStatus$ | async">
  <div class="loader-spinner" aria-label="Loading"></div>
</div>
